import { env } from "config";

/**
 * Instance region. The codebase is shared between the global (jmix.io) and the Russian
 * (jmix.ru) instances; region-specific behavior (language, legal links, social blocks)
 * is switched at runtime via the REACT_APP_REGION container variable.
 *
 * Anything unrecognized falls back to GLOBAL, so existing deployments keep their behavior.
 */
export enum Region {
  GLOBAL = "global",
  RU = "ru",
}

export function getRegion(): Region {
  const value = (env.REACT_APP_REGION || "").toLowerCase();
  return value === Region.RU ? Region.RU : Region.GLOBAL;
}

export function isRu(): boolean {
  return getRegion() === Region.RU;
}

/** Locale requested from Keycloak login pages (ui_locales); undefined keeps server defaults. */
export function getKeycloakLocale(): string | undefined {
  return isRu() ? "ru" : undefined;
}
